<template>
  <div
    v-if="
      (neopassDatas[constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES] &&
        Object.values(
          neopassDatas[constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES]
        ).length > 0) ||
      (neopassDatas[constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE] &&
        Object.values(
          neopassDatas[constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE]
        ).length > 0)
    "
  >
    <div
      v-for="(version, refName) in neopassDatas[
        constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
      ]"
      :key="refName"
    >
      <div v-for="(evaluation, numVersion) in version" :key="numVersion">
        <h3 class="xl:my-15">
          {{
            refName +
            (Object.values(version).length > 1 ? ' V' + numVersion : '')
          }}
        </h3>

        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 items-center"
        >
          <div
            v-for="(competence, kcomp) in evaluation"
            :key="kcomp"
            class="col-span-1"
          >
            <bar
              :id-chart="refName + numVersion + kcomp"
              :title="competence.title"
              orientation="vertical"
              :labels="competence.labels"
              :values="competence.datasets"
              height="500"
              width="400"
              :stacked="true"
              :display-legend="true"
              :display-values="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-for="(version, refName) in neopassDatas[
        constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
      ]"
      :key="refName"
    >
      <div v-for="(evaluation, numVersion) in version" :key="numVersion">
        <h3 class="my-15">
          {{
            refName +
            (Object.values(version).length > 1 ? ' V' + numVersion : '')
          }}
        </h3>

        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 items-center"
        >
          <div
            v-for="(competence, kcomp) in evaluation"
            :key="kcomp"
            class="col-span-1"
          >
            <bar
              :id-chart="refName + numVersion + kcomp"
              :title="competence.title"
              orientation="vertical"
              :labels="competence.labels"
              :values="competence.datasets"
              height="500"
              width="400"
              :stacked="true"
              :display-legend="true"
              :display-values="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="text-center mt-1/10 text-gray-600">
    Aucune donnée à afficher.
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '../../../components/Icon';
import ActionButton from '../../../components/ActionButton';
import Bar from '../../../components/Charts/Bar';

import Constants from './../../../constants';

export default {
  components: {
    Icon,
    ActionButton,
    Bar,
  },

  name: 'CartoColCompetencesCles',

  data() {
    return {
      constants: Constants,
    };
  },
  mounted() {
    //
  },
  methods: {
    ...mapMutations({
      //
    }),
    color(c) {
      if (c == 'indigo') {
        return '#3A18D1';
      } else if (c == 'pink') {
        return '#FF1C80';
      } else if (c == 'twelveColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
          '#CE5AE3',
          '#F9A1D4',
        ];
      } else if (c == 'elevenColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
          '#CE5AE3',
        ];
      } else if (c == 'tenColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
          '#F7CD55',
        ];
      } else if (c == 'nineColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
          '#FFA466',
        ];
      } else if (c == 'eightColors') {
        return [
          '#3211C2',
          '#7B6AFF',
          '#DFE0F2',
          '#FF1C80',
          '#21B8C8',
          '#FF3900',
          '#ABD952',
          '#7BC5F9',
        ];
      } else if (c == 'evaluation') {
        return [
          '#FBE6F0',
          '#FEF3F8',
          '#FFEDE3',
          '#FFF6F1',
          '#DFE0F2',
          '#FAF7FC',
          '#EAF5F6',
          '#D3F1F5',
        ];
      }
    },
  },
  computed: {
    ...mapGetters({
      neopassDatas: 'cartographiesCollectives/neopassDatas',
    }),
  },
};
</script>
